export default function Promise() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            저희의 약속은 3가지입니다.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            이 단순한 원칙이 품질을 만듭니다.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {/* 제대로 키웁니다 */}
          <div className="bg-gradient-to-br from-[#FDFBF7] to-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full mb-6">
              <i className="ri-plant-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              제대로 키웁니다.
            </h3>
            <p className="text-gray-600 leading-relaxed">
              약품을 쓰지 않고 천연 유기 퇴비로만 재배합니다. 자연의 순리를 따르는 재배가 포도 본연의 깊고 진한 맛을 만듭니다.
            </p>
          </div>

          {/* 제대로 짭니다 */}
          <div className="bg-gradient-to-br from-[#FDFBF7] to-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full mb-6">
              <i className="ri-flask-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              제대로 짭니다.
            </h3>
            <p className="text-gray-600 leading-relaxed">
              청정 암반수 세척, 고당도 선별, 저온 착즙으로 포도의 맛과 향을 온전히 보존합니다. 타협 없는 공정이 품질을 완성합니다.
            </p>
          </div>

          {/* 제대로 드립니다 */}
          <div className="bg-gradient-to-br from-[#FDFBF7] to-white rounded-2xl p-8 border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full mb-6">
              <i className="ri-heart-pulse-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              제대로 드립니다.
            </h3>
            <p className="text-gray-600 leading-relaxed">
              100% 포도 원액만 담습니다. 물, 설탕, 향료 무첨가. 포도 그 자체의 농도와 가치를 그대로 전달합니다.
            </p>
          </div>
        </div>

        <div className="text-center mt-16">
          <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
            포도즙은 결국 원료와 공정이 품질을 결정합니다.<br />
            저희는 그 기본을 가장 철저하게 지킵니다.<br />
            품질의 기준을 과정으로 증명합니다.
          </p>
        </div>
      </div>
    </section>
  );
}
